import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProductsTable } from "@/components/admin/price-book/ProductsTable";
import { PricesGrid } from "@/components/admin/price-book/PricesGrid";
import { PriceBookSettings } from "@/components/admin/price-book/PriceBookSettings";

export default function PriceBook() {
  const [activeTab, setActiveTab] = useState("products");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Price Book Manager</h1>
        <p className="text-muted-foreground mt-2">
          Manage products, pricing, and county-specific price books
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="products">Products</TabsTrigger>
          <TabsTrigger value="pricing">Pricing</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
        </TabsList>

        <TabsContent value="products" className="mt-6">
          <ProductsTable />
        </TabsContent>

        <TabsContent value="pricing" className="mt-6">
          <PricesGrid />
        </TabsContent>

        <TabsContent value="settings" className="mt-6">
          <PriceBookSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
}
